import { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    // Auto-hide toast after 3 seconds
    setTimeout(() => {
      setToast({ message: "", type: "success" });
    }, 3000);
  };

  const hideToast = () => {
    setToast({ message: "", type: "success" });
  };

  return (
    <ToastContext.Provider value={{ toast, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === null) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
